module.exports = __webpack_public_path__ + "static/maquette1-e0349e5050636c0ba242fa4eda1a0e2d.jpg";